import axios from 'axios';
import APIS from '../../apis';
import {callbackHandler} from '../callbackHandler';
import qs from 'qs';
export default {
    getters: {},
    actions: {
        /**
         * 在报告页获取 有否评价过的接口
         * @param context
         * @param params
         * @param callback
         */
        [`GET_REPORT_HASCOMMENT`]: function (context, {params, callback} = {}) {
            return axios.get(APIS.reportShowComment, {
                params
            }).then((res) => {
                callbackHandler(APIS.reportShowComment, res, callback);
                return res.data;
            })
        },
        /**
         * 发表评论
         * @param context
         * @param params
         * @param callback
         */
        [`PUBLISH_COMMENT`]: function (context, {params, callback} = {}) {
            // console.info(qs.stringify(evaluationItem));
            return axios.post(APIS.publishComment, qs.stringify({evaluationItem: params})).then((res) => {
                callbackHandler(APIS.publishComment, res, callback);
                return res.data;
            })
        },
        /**
         * 删除评论
         * @param context
         * @param params -> channelId, scalePoolId, orderId
         * @param callback
         */
        [`DELETE_COMMENT`]: function (context, {params, callback}) {
            axios.get(APIS.deleteComment, {
                params
            }).then((res) => {
                callbackHandler(APIS.deleteComment, res, callback);
            })
        },
        /**
         * 未评价测评
         * @param context
         * @param params
         * @param callback
         * @returns {*}
         */
        [`GET_UNCOMMENT_SCALES`]: function (context, {params, callback}) {
            return axios.get(APIS.getUnCommentScales, {
                params
            }).then((res) => {
                callbackHandler(APIS.getUnCommentScales, res, callback);
                return res.data;
            })
        },
        /**
         * 获取我的测评
         * @param context
         * @param params -> orderId
         * @param callback
         */
        [`GET_MY_COMMENT`]: function (context, {params, callback}) {
            axios.get(APIS.getMyComment, {
                params
            }).then((res) => {
                callbackHandler(APIS.getMyComment, res, callback);
            })
        },
        [`GET_ALL_COMMENT`]: function(context, {params}){
            return axios.get(APIS.allComment,{
                params
            }).then((res) => {
                callbackHandler(APIS.getMyComment, res);
                return res.data
            })
        },
        /**
         * 获取精选评价
         * @param context
         * @param params -> scalePoolId
         * @param callback
         */
        [`GET_HANDPICK_COMMENT`]: function (context, {params, callback}) {
            axios.get(APIS.getHandpickComments, {
                params
            }).then((res) => {
                callbackHandler(APIS.getHandpickComments, res, callback);
            })
        },
        /**
         * 获取最新评价
         * @param context
         * @param params
         * @param callback
         */
        [`GET_LATEST_COMMENT`]: function (context, {params, callback}) {
            axios.get(APIS.getLatestComments, {
                params
            }).then((res) => {
                callbackHandler(APIS.getLatestComments, res, callback);
            })
        },
        /**
         * 获取测评详情页的评价数据
         * @param context
         * @param params
         * @param callback
         */
        [`GET_DETAIL_COMMENT`]: function(context, params){
            console.log(params)
            console.log('GET_DETAIL_COMMENT')
          if((params.channelId == 2278 ||params.channelId == 2310) && (params.scalePoolId == 566 || params.scalePoolId == 587)){
            console.log('2278 2310渠道且566ID的评论数据，后续需要处理')
            return Promise.resolve(require('./commentData_id566_channel2278.json'))
          } else {
            return axios.get(APIS.getDetailPageComments, {
              params
            }).then((res) => {
              callbackHandler(APIS.getDetailPageComments, res);
              return res.data;
            })
          }
          

        },

        getCpReportResult(context, params) {
            return axios.get(APIS.getCpReportResult, {
                params
            }).then((res) => {
                callbackHandler(APIS.getCpReportResult, res)
                return res.data
            })
        },

        getConfigureByCode(context, params) {
            return axios.get(APIS.getConfigureByCode, {
                params
            }).then((res) => {
                return res.data
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/comment.js